export const starTaxContractAddress = "0xc756C791268D7C2728113A2Ff48cA46548200906";
export const starTaxContractABI = [
  {
    "anonymous": false,
    "inputs": [
      { "indexed": false, "internalType": "uint256", "name": "newCounter", "type": "uint256" }
    ],
    "name": "TransactionCounterUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": false, "internalType": "uint256", "name": "newMinimum", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "tokenPriceInETH", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "ethToStablecoinPrice", "type": "uint256" }
    ],
    "name": "MinimumTransactionUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "newReceiver10", "type": "address" },
      { "indexed": true, "internalType": "uint256", "name": "transactionNumber", "type": "uint256" }
    ],
    "name": "NewReceiver10",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "newReceiver100", "type": "address" },
      { "indexed": true, "internalType": "uint256", "name": "transactionNumber", "type": "uint256" }
    ],
    "name": "NewReceiver100",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "newReceiver1000", "type": "address" },
      { "indexed": true, "internalType": "uint256", "name": "transactionNumber", "type": "uint256" }
    ],
    "name": "NewReceiver1000",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "newReceiver10000", "type": "address" },
      { "indexed": true, "internalType": "uint256", "name": "transactionNumber", "type": "uint256" }
    ],
    "name": "NewReceiver10000",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "newReceiver100000", "type": "address" },
      { "indexed": true, "internalType": "uint256", "name": "transactionNumber", "type": "uint256" }
    ],
    "name": "NewReceiver100000",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "newReceiver1000000", "type": "address" },
      { "indexed": true, "internalType": "uint256", "name": "transactionNumber", "type": "uint256" }
    ],
    "name": "NewReceiver1000000",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "transactionCounter",
    "outputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "transactionMinimum",
    "outputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "currentReceiver10",
    "outputs": [
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "currentReceiver100",
    "outputs": [
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "currentReceiver1000",
    "outputs": [
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "currentReceiver10000",
    "outputs": [
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "currentReceiver100000",
    "outputs": [
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "currentReceiver1000000",
    "outputs": [
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "account", "type": "address" }
    ],
    "name": "balanceOf",
    "outputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];

export const jackpotTaxReceiverAddress = "0x9C070b1a5b60e4120C9c0Ea0CD246456e701E071";
export const jackpotTaxReceiverABI = [
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "receiver", "type": "address" },
      { "indexed": false, "internalType": "uint256", "name": "fiboNumber", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "potSnapshot", "type": "uint256" }
    ],
    "name": "NewFiboReceiver",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "claimer", "type": "address" },
      { "indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256" }
    ],
    "name": "JackpotClaimed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "uint256", "name": "timestamp", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "totalBalance", "type": "uint256" },
      { "indexed": false, "internalType": "address", "name": "lastReceiver", "type": "address" }
    ],
    "name": "JackpotBalanceAnnounced",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "fibPot",
    "outputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "lastFiboReceiver",
    "outputs": [
      { "internalType": "address", "name": "", "type": "address" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "lastFiboNumber",
    "outputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "chipsToken",
    "outputs": [
      { "internalType": "contract IERC20", "name": "", "type": "address" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "claimJackpot",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "announceJackpotBalance",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];
